export default "__VITE_ASSET__DzmkY6vW__"